import request from '@/utils/request.js'

export function queryCompetitionPage(processFormId, pageNum, pageSize, queryParams) {
    const data = {
        pageNum,
        pageSize,
        queryParams
    }
    return request({
        url: '/modules/ma/queryPage',
        method: 'post',
        data: data,
        params: {processFormId}
    })
}

export function getScoreInform(pageNum, pageSize, queryParams,competeId) {
    const data = {
        pageNum,
        pageSize,
        queryParams
    }
    return request({
        url: '/modules/re/getScoreInform',
        method: 'post',
        data: data,
        params: {processFormId: '06a79d82bed5688c828eb8fe1580ad1a',competeId}
    })
}

export function updateInfo(data) {

    return request({
        url: '/modules/info/update',
        method: 'post',
        data: data,
    })
}

export function getLoginInfo() {
    return request({
        url: '/modules/info/getLoginInfo',
        method: 'get',
    })
}

// 文件下载前获取校验Token
export function getDownloadToken(params) {
    return request({
        url: '/system/file/getDownloadToken',
        method: 'get',
        params
    })
}
